
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { badgeSchemas, ScorecardEntity } from '@/entities/scorecard'
import { IResponse } from '@/entities'
import { getQuestionClass, getQuestionType } from '@/domain/NPS'
import { timeSince } from '@/utils/time'
import { clamp } from '@/utils/clamp'
import { isFiveScoreQuestionType } from '@/utils/globalVariables'
import { embedded, postMessageToRNWebView } from '@/utils/react-native-webview'

@Component<ScorecardResponseTile>({
    filters: {
        timeSince,
    },
})
export default class ScorecardResponseTile extends Vue {
    @Prop() public scorecard!: ScorecardEntity
    @Prop() public response!: IResponse
    @Prop({ type: Boolean, default: true }) public showBadge!: boolean

    public get type() {
        if (!this.scorecard) {
            return 'nps'
        }
        return getQuestionType(this.scorecard.leaderboard, 'ReceiveOption')
    }

    public badgeLabel(badge) {
        return badge.label || badge.badge
    }

    public getQuestionClass(response: IResponse) {
        return getQuestionClass(
            response.answer,
            isFiveScoreQuestionType(response.question_type) ? '5star' : 'nps'
        )
    }

    public mounted() {
        clamp(this.$refs.comment, { clamp: 3 })
    }

    public badgeStyle(badge) {
        if (!badge) {
            return ''
        }
        if ((badge as any).type === 'positive' && badgeSchemas[badge.badge]) {
            const { foreColor, backColor } = badgeSchemas[badge.badge]
            return `backgroundColor: ${backColor}; color: ${foreColor}`
        } else {
            return `backgroundColor: #F4F6FC; color: #A9B4CB;`
        }
    }

    public onClickResponse() {
        if (embedded) {
            postMessageToRNWebView({
                action: 'Chat',
                params: {
                    responseId: this.response.id.toString(),
                },
            })
        } else {
            this.$emit('click')
        }
    }
}
